import React, { useMemo } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import set from 'lodash.set';

import { SidebarContentsQuery } from '../../../../graphql-types';

import { SidebarValue } from './types';
import { SidebarItem } from './SidebarItem';
import { SidebarWrapper } from './styles';

export interface SidebarProps {
  location?: string[];
  showIndex?: boolean;
}

export const Sidebar: React.FC<SidebarProps> = ({ location, showIndex }) => {
  const { allAsciidoc } = useStaticQuery<SidebarContentsQuery>(graphql`
    query SidebarContents {
      allAsciidoc {
        edges {
          node {
            id
            document {
              main
            }
            fields {
              slug
              location
            }
            pageAttributes {
              sidebar_index
              sidebar_title
            }
          }
        }
      }
    }
  `);

  const contents = useMemo(() => {
    if (!location || location.length === 0) {
      return null;
    }

    const parent = location[0];

    const nodes = allAsciidoc.edges
      .filter((e) => e.node.fields.location?.[0] === parent)
      .map((e) => e.node);

    let map: SidebarValue = {};

    nodes.forEach((n) => {
      const { location: l } = n.fields;

      if (l.length < 1) {
        return;
      }

      if (l.length === 1) {
        if (!showIndex) {
          return;
        }

        map = {
          ...map,
          [l[0]]: n,
        };

        return;
      }

      const rest = l.slice(1);

      map = set(map, rest, n);
    });

    console.log(map);

    return <SidebarItem value={map} />;
  }, [allAsciidoc, location, showIndex]);

  return <SidebarWrapper>{contents}</SidebarWrapper>;
};
